<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">人車流統計(內部參考)</div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              統計篩選條件
            </div>
            <div class="row h6">
              <div class="col-12 mt-2">
                <form class="form-inline">
                  <label class="my-1 mr-2" for="inlineFormCustomSelectPref"
                    >選擇風景區</label
                  >
                  <select
                    class="custom-select my-1 mr-sm-2"
                    id="inlineFormCustomSelectPref"
                  >
                    <option value="1">石梯坪</option>
                    <option value="2">三仙台</option>
                  </select>
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇起日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-01"
                  />
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇訖日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-03"
                  />
                  <button type="submit" class="btn btn-primary my-1">
                    送出查詢
                  </button>
                  <button type="submit" class="btn btn-primary my-1 ml-2">
                    匯出Excel
                  </button>
                  <!-- <button
                    type="button"
                    class="btn btn-success my-1 ml-2"
                    data-toggle="modal"
                    data-target="#exampleModalCenter"
                  >
                    手動調整
                  </button> -->
                </form>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12 table-responsive">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" rowspan="2">統計日期</th>
                      <th scope="col" colspan="2">大型車</th>
                      <th scope="col" colspan="2">小型車</th>
                      <th scope="col" colspan="2">機車</th>
                      <th scope="col" colspan="2">SUV</th>
                      <th scope="col" colspan="2">人流(估)</th>
                    </tr>
                    <tr>
                      <th scope="col">數量</th>
                      <th scope="col">累計數量</th>
                      <th scope="col">數量</th>
                      <th scope="col">累計數量</th>
                      <th scope="col">數量</th>
                      <th scope="col">累計數量</th>
                      <th scope="col">數量</th>
                      <th scope="col">累計數量</th>
                      <th scope="col">數量(人)</th>
                      <th scope="col">累計數量(人)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in dashbords"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ item.date }}</td>
                      <td class="bg-info text-white">{{ item.bigcount }}</td>
                      <td>{{ item.bigsum }}</td>
                      <td class="bg-info text-white">{{ item.smallcount }}</td>
                      <td>{{ item.smallsum }}</td>
                      <td class="bg-info text-white">{{ item.motocount }}</td>
                      <td>{{ item.motosum }}</td>
                      <td class="bg-info text-white">{{ item.suvcount }}</td>
                      <td>{{ item.psum }}</td>
                      <td class="bg-info text-white">{{ item.suvcount }}</td>
                      <td>{{ item.psum }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手動調整Modal -->
    <div class="modal fade" id="exampleModalCenter">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5">手動調整</div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group h6">
              <label for="exampleInputEmail1">日期</label
              ><input
                type="date"
                id="exampleInputEmail1"
                class="form-control"
              />
            </div>
            <div class="form-group h6">
              <label for="exampleInputEmail1">類別</label
              ><select
                id="inlineFormCustomSelectPref"
                class="custom-select my-1 mr-sm-2"
              >
                <option value="1">人數</option>
                <option value="2">大型車</option>
                <option value="3">小型車</option>
                <option value="4">機車</option>
              </select>
            </div>
            <div class="form-group h6">
              <label for="exampleInputEmail1">調整</label
              ><input
                type="email"
                id="exampleInputEmail1"
                placeholder="增加"
                class="form-control"
              />
              <input
                type="email"
                id="exampleInputEmail1"
                placeholder="減少"
                class="form-control"
              />
            </div>
            <div class="form-group h6">
              <label for="exampleFormControlTextarea1">請填入原因(必填)</label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary">儲存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          date: "2022/02/01",
          bigcount: "2",
          bigsum: "2",
          smallcount: "5",
          smallsum: "5",
          motocount: "20",
          motosum: "20",
          suvcount: "20",
          suvsum: "20",
          pcount: "100",
          psum: "100",
        },
        {
          date: "2022/02/02",
          bigcount: "1",
          bigsum: "3",
          smallcount: "7",
          smallsum: "12",
          motocount: "30",
          motosum: "50",
          suvcount: "20",
          suvsum: "40",
          pcount: "108",
          psum: "208",
        },
        {
          date: "2022/02/03",
          bigcount: "3",
          bigsum: "6",
          smallcount: "15",
          smallsum: "27",
          motocount: "10",
          motosum: "60",
          suvcount: "20",
          suvsum: "60",
          pcount: "140",
          psum: "348",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>